import React from 'react'

import { required } from 'src/helpers/column/Pemakaian/Tambah'
import { request } from 'src/helpers/request'

import CustomRenderSelect from 'src/helpers/column/Pelanggan/Form/SelectTanggal'

export const toSnakeCase = (str = '') => {
  if (!str) return str
  const strArr = str?.split(' ')
  const snakeArr = strArr?.reduce((acc, val) => {
    return acc.concat(val.toLowerCase())
  }, [])
  return snakeArr?.join('_')
}

const simpleMemoize = (fn) => {
  let lastArg
  let lastResult
  return (arg) => {
    if (arg !== lastArg) {
      lastArg = arg
      lastResult = fn(arg)
    }
    return lastResult
  }
}

export const usernameAvailable = simpleMemoize(async (value) => {

  if (!value) {
    return 'Anda belum menambahkan pengguna'
  }

  try {
    await request('get', `/check_username?q=${value}&method=username`)
    return undefined
  } catch (error) {
    return 'username telah tersedia'
  }
})

export const userPekerjaCheck = simpleMemoize(async (value) => {
  if (!value) {
    return 'Required'
  }
  try {
    await request('get', `/check_user_pekerja?q=${value}&method=username`)
    return undefined
  } catch (error) {
    return 'username telah tersedia'
  }
})

export const cekNIK = simpleMemoize(async (value) => {
  if (!value) {
    return 'Nik belum terisi'
  }
  try {
    await request('get', `/check_username?q=${value}&method=nik`)
    return undefined
  } catch (error) {
    return 'NIK telah tersedia'
  }
})

export const cekNIKReseller = simpleMemoize(async (value) => {
  if (!value) {
    return 'Nik belum terisi'
  }
  try {
    await request('get', `/check_username?q=${value}&method=nik&actions=reseler`)
    return undefined
  } catch (error) {
    return 'NIK telah tersedia'
  }
})

export const cekNoHp = simpleMemoize(async (value) => {
  if (!value) {
    return 'No Hp belum terisi'
  }
  try {
    await request('get', `/check_username?q=${value}&method=no_hp`)
    return undefined
  } catch (error) {
    return 'No Hp telah tersedia'
  }
})
export const cekNoHpReseler = simpleMemoize(async (value) => {
  if (!value) {
    return 'No Hp belum terisi'
  }
  try {
    await request('get', `/check_username?q=${value}&method=no_hp&actions=reseler`)
    return undefined
  } catch (error) {
    return 'No Hp telah tersedia'
  }
})

const form_mitra = [
  {
    layOut: 'formGroupVerticalAndLabel',
    content: [
      {
        name: 'id_mitra',
        type: 'text',
        label: 'ID Mitra',
        layOut: 'formGroupHorizontal',
        validate: required('ID Mitra'),
        readOnly: true,
        size: 'sm',
      },
      {
        name: 'nama_mitra',
        type: 'text',
        layOut: 'formGroupHorizontal',
        label: 'Nama Mitra',
        validate: required('Nama Mitra'),
        size: 'sm',
      },
      {
        name: 'nama_usaha_mitra',
        type: 'text',
        placeholder: 'Nama Usaha Mitra',
        label: 'Nama Usaha Mitra',
        layOut: 'formGroupHorizontal',
        validate: required('Nama Usaha Mitra'),
        size: 'sm',
      },
    ],
  },
  {
    layOut: 'formGroupVerticalAndLabel',
    content: [
      {
        name: 'nik',
        type: 'text',
        placeholder: 'nik',
        label: 'NIK',
        layOut: 'formGroupHorizontal',
        validate: cekNIKReseller,
        size: 'sm',
      },
      {
        name: 'id_layanan',
        type: 'select',
        data: [],
        label: 'PACKET LAYANAN',
        validate: required('Packet Layanan'),
        placeholder: '--Pilih Packet --',
        layOut: 'formGroupHorizontal',
        size: 'sm',
      },
    ],
  },
  {
    name: 'alamat',
    type: 'textarea',
    label: 'Alamat',
    layOut: 'formGroupHorizontal',
    validate: required('Alamat'),
    size: 'sm',
    rows: '4',
  },
  {
    layOut: 'formGroupVerticalAndLabel',
    content: [
      {
        name: 'no_hp',
        type: 'text',
        label: 'No Hp',
        data: [],
        size: 'sm',
        placeholder: 'Nomor Hp',
        layOut: 'formGroupHorizontal',
        validate: required('Nomor Hp'),
      },
      {
        name: 'tanggal_register',
        type: 'select',
        label: 'Tanggal Register',
        size: 'sm',
        data: [],
        customRender: <CustomRenderSelect />,
        validate: required('Tanggal Register'),
      },
    ],
  },
  {
    layOut: 'formGroupVerticalAndLabelCalout',
    label: 'Buatkan user login untuk masuk ke System sebagai mitra',
    content: [
      {
        name: 'username',
        type: 'text',
        label: 'Username',
        data: [],
        placeholder: 'Username',
        layOut: 'formGroupHorizontal',
        size: 'sm',
        validate: usernameAvailable,
      },
      {
        name: 'password',
        type: 'password',
        label: 'Kata Sandi',
        data: [],
        placeholder: 'Kata Sandi',
        layOut: 'formGroupHorizontal',
        validate: required('Kata Sandi'),
        size: 'sm',
      },
      {
        name: 're_password',
        type: 'password',
        label: 'Konfirmasi Kata Sandi',
        data: [],

        layOut: 'formGroupHorizontal',
        validate: required('Pengulangan Kata Sandi'),
        size: 'sm',
      },
    ],
  },
]
const form_reseler = [
  {
    layOut: 'formGroupVerticalAndLabel',
    content: [
      {
        name: 'id_reseller',
        type: 'text',
        label: 'ID Reseller',
        layOut: 'formGroupHorizontal',
        validate: required('ID Reseller'),
        readOnly: true,
        size: 'sm',
      },
      {
        name: 'nama_reseller',
        type: 'text',
        layOut: 'formGroupHorizontal',
        label: 'Nama Reseller',
        validate: required('Nama Reseller'),
        size: 'sm',
      },
      {
        name: 'nama_usaha_reseller',
        type: 'text',
        layOut: 'formGroupHorizontal',
        label: 'Nama Usaha reseller',
        validate: required('Nama Reseller'),
        size: 'sm',
      },
    ],
  },
  {
    layOut: 'formGroupVerticalAndLabel',
    content: [
      {
        name: 'nik',
        type: 'text',
        placeholder: 'nik',
        label: 'NIK',
        layOut: 'formGroupHorizontal',
        validate: cekNIKReseller,
        size: 'sm',
      },
      {
        name: 'id_layanan',
        type: 'select',
        data: [],
        label: 'PACKET LAYANAN',
        validate: required('Packet Layanan'),
        placeholder: '--Pilih Packet --',
        layOut: 'formGroupHorizontal',
        size: 'sm',
      },
    ],
  },
  {
    name: 'alamat',
    type: 'textarea',
    label: 'Alamat',
    layOut: 'formGroupHorizontal',
    validate: required('Alamat'),
    size: 'sm',
    rows: '2',
  },
  {
    layOut: 'formGroupVerticalAndLabel',
    content: [
      {
        name: 'no_hp',
        type: 'text',
        label: 'No Hp',
        data: [],
        size: 'sm',
        placeholder: 'No Hp',
        layOut: 'formGroupHorizontal',
        validate: required('No Hp'),
      },
      {
        name: 'tanggal_register',
        type: 'select',
        label: 'Tanggal Register',
        size: 'sm',
        data: [],
        customRender: <CustomRenderSelect />,
        validate: required('Tanggal Register'),
      },
    ],
  },
  {
    layOut: 'formGroupVerticalAndLabelCalout',
    label: 'Buatkan user login untuk masuk ke System sebagai reseler',
    content: [
      {
        name: 'username',
        type: 'text',
        label: 'Username',
        data: [],
        placeholder: 'Username',
        layOut: 'formGroupHorizontal',
        size: 'sm',
        validate: usernameAvailable,
      },
      {
        name: 'password',
        type: 'password',
        label: 'Kata Sandi',
        data: [],
        placeholder: 'Kata Sandi',
        layOut: 'formGroupHorizontal',
        validate: required('Kata Sandi'),
        size: 'sm',
      },
      {
        name: 're_password',
        type: 'password',
        label: 'Konfirmasi Kata Sandi',
        data: [],

        layOut: 'formGroupHorizontal',
        validate: required('Pengulangan Kata Sandi'),
        size: 'sm',
      },
    ],
  },
]

export const content_form = {
  form_mitra,
  form_reseler,
}
